<article class="block-intro section-outset-y container">
  <h2 class="fs-body-md block-intro__subtitle subtitle-label mb-4" *ngIf="block.title" [innerHTML]="block.title | highlight"></h2>

  <div class="justify-content-between row">
    <div class="col-12 col-lg-7 block-intro__text" *ngIf="block.intro">
      <!--<p
        class="block-intro__text__paragraph h4 mb-0 splitting--fade-lines"
        splitting
        by="lines"
        [class.anim--active]="inviewPort"
        *ngIf="block.intro"
      >
        {{ block.intro }}
      </p>-->
      <p class="block-intro__text__paragraph h4 mb-0 anim-fade-up" [class.anim--active]="inviewPort" *ngIf="block.intro">
        {{ block.intro }}
      </p>
    </div>

    <div class="col-12 col-lg-5 block-intro__content mt-5 mt-lg-0" *ngIf="block.listItems?.length || block.button?.url">
      <ul class="bullet-list" *ngIf="block.listItems?.length">
        <li class="bullet-list__item" *ngFor="let item of block.listItems">
          <span>{{ item.title }}</span>
        </li>
      </ul>
      <div class="block-intro__cta mt-auto" *ngIf="block.button?.url">
        <span class="fs-body-md fw-light" *ngIf="block.label">{{ block.label }}</span>
        <fstr-link cssClasses="button button button--primary-gradient has--dot" [button]="block.button!">
          <ng-container *ngIf="!block.button?.text">{{ 'lees-meer' | fromDictionary }}</ng-container>
        </fstr-link>
      </div>
    </div>
  </div>
</article>
